import React from 'react'
import axios from 'axios'
import {useState, useEffect} from 'react'

const Pagination = ({paginate, test}) => {
  const pageNumbers = []
  const [getUrl, setUrl] = useState([])

  for (let i = 0; i < test?.length; i++) {
    pageNumbers.push(i)
  }

  return (
    <>
      <nav>
        <ul className='pagination'>
          {/* <a onClick={() => paginatePrev()} className='page-link'>
                    <i className='bi bi-arrow-left-short'></i>
                </a> */}
          {pageNumbers.map((number) => (
            <li key={number} className='page-item'>
              {test[number]?.active === true ? (
                <a onClick={() => paginate(test[number]?.url)} className={'page-link active'}>
                  {number == 0 ? (
                    <label>&#171;</label>
                  ) : (
                    <>
                      {number == pageNumbers.length - 1 ? (
                        <label>&#187;</label>
                      ) : (
                        <label>{test[number].label}</label>
                      )}
                    </>
                  )}
                </a>
              ) : (
                <a onClick={() => paginate(test[number]?.url)} className={'page-link'}>
                  {number == 0 ? (
                    <label>&#171;</label>
                  ) : (
                    <>
                      {number == pageNumbers.length - 1 ? (
                        <label>&#187;</label>
                      ) : (
                        <label>{test[number].label}</label>
                      )}
                    </>
                  )}
                </a>
              )}
            </li>
          ))}
          {/* <a onClick={() => paginateNext()}  className='page-link'>
                    <i className='bi bi-arrow-right-short'></i>
                </a> */}
        </ul>
      </nav>
    </>
  )
}
export default Pagination
